import { render, staticRenderFns } from "./FileUploadDropzone.vue?vue&type=template&id=84d5e7b0&scoped=true"
import script from "./FileUploadDropzone.vue?vue&type=script&lang=js"
export * from "./FileUploadDropzone.vue?vue&type=script&lang=js"
import style0 from "./FileUploadDropzone.vue?vue&type=style&index=0&id=84d5e7b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d5e7b0",
  null
  
)

export default component.exports